module.exports = __webpack_public_path__ + "img/profile_sp.d629602f.png";